const OperationalInsightsList = ({
  insights,
}) => {
  const insightsList = insights?.getSortedBySeverity() ?? [];

  const loading = insights === null;


  const insightsListJsx = insightsList.map((insight, index) => (
    <div key={index} className="mt-2">
      <div>
        <strong>{insight.issueTitle}</strong>: {insight.summary}
      </div>
      <div className="affected-header">Affected business:</div>
      <ul>
        {insight.locations.map((location, locIndex) => (
          <li key={locIndex}>{location}</li>
        ))}
      </ul>
    </div>
  ));

  return (
    <div className="insights-container">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            marginBottom: "20px",
            height: "40px",
          }}
        >
          <div className="sub-title">Operational insights</div>
        </div>
      {loading ? ( 
        <div className="shimmer-container">
          <div className="shimmer" style={{ width: "100%" }}></div>
          <div className="shimmer" style={{ width: "60%" }}></div>
          <div className="shimmer" style={{ width: "100%" }}></div>
          <div className="shimmer" style={{ width: "60%" }}></div>
          <div className="shimmer" style={{ width: "100%" }}></div>
          <div className="shimmer" style={{ width: "60%" }}></div>
        </div>
      ) : insightsList.length > 0 ? (
        insightsListJsx
      ) : (
        <div className="fs-6 text-muted">No insights available</div>
      )}
    </div>
  );
};

export default OperationalInsightsList;
